/**
 * AdminTabSpec describes the admin-only tabs.
 * The existing AdminTab union in AdminConsoleView.tsx is extended to include
 * these keys. This interface makes the new tab metadata explicit and
 * self-documenting so subsequent PRs can import it.
 *
 * Spec 4 PR 5 adds "connect-agents" — the 12th tab, admin-only.
 */
export type AdminOnlyTab =
  | "plan-billing"
  | "team-roles"
  | "github-integration"
  | "credentials-vault"
  | "connect-agents"
  | "cost-dashboard"
  | "egress";

export interface AdminTabSpec {
  key: AdminOnlyTab;
  label: string;
  /** Which PR number fully implements this tab (stub shows "Coming in PR N"). */
  implementedInPr: 2 | 3 | 4 | 5 | 10;
}

export const ADMIN_ONLY_TABS: ReadonlyArray<AdminTabSpec> = [
  { key: "plan-billing", label: "Plan & billing", implementedInPr: 2 },
  { key: "team-roles", label: "Team & roles", implementedInPr: 3 },
  { key: "github-integration", label: "GitHub integration", implementedInPr: 4 },
  { key: "credentials-vault", label: "Credentials vault", implementedInPr: 5 },
  { key: "connect-agents", label: "Connect agents", implementedInPr: 5 },
  { key: "cost-dashboard", label: "Cost dashboard", implementedInPr: 10 },
  // F2d — Egress allow-list management. Admin-only because the egress
  // add/remove mutations are admin-gated server-side, like the firewall.
  { key: "egress", label: "Egress allow-list", implementedInPr: 5 },
];
